var _linearGradient, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeparture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 17 14",
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 2.14373,
    x2: 17.4223,
    y1: -0.000001,
    y2: 15.0557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a91e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99e1e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.52602 4.33149c.44027-2.0734.66041-3.11009 1.45313-3.720791.79273-.610699 1.91828-.610699 4.1694-.610699h5.52965c2.2257 0 3.3386 0 3.9402.675921.6016.675919.4042 1.704539.0095 3.761769l-.9848 5.13263c-.4063 2.11758-.6095 3.17638-1.4077 3.80308-.7981.6266-1.9437.6266-4.2347.6266h-5.63506c-2.26381 0-3.395717 0-3.997812-.6894-.602094-.6894-.3807151-1.7319.062043-3.81702z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.8315 4.75h-2.83151v-1.5h5.91481l-1.1794 5.89709-1.4708-.29418.6016-3.00827-5.40285 4.24506-.92673-1.17944z",
    fill: "#faf7f2",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeparture);
export default __webpack_public_path__ + "static/media/departure.c8167024669befe62f730fdc66ec8a03.svg";
export { ForwardRef as ReactComponent };